export enum ACTIONS {
    'CREATE' = 'CREATE',
    'EDIT' = 'EDIT',
    'VIEW' = 'VIEW',
    'DELETE' = 'DELETE',
    'SELECT' = 'SELECT',
    'PREVIEW_FILE' = 'PREVIEW_FILE',
    'PREVIEW_SAMPLE' = 'PREVIEW_SAMPLE',
    'DOWNLOAD' = 'DOWNLOAD',
    'UPLOAD' = 'UPLOAD',
    'SIGN' = 'SIGN',
    'CHAT' = 'CHAT',
    'CLOSE' = 'CLOSE',
    'SEND' = 'SEND',
    'RESEND' = 'RESEND',
}

export const yesNoOption = ['Yes', 'No'];

export const booleanOption = { Yes: true, No: false };
